import React from 'react';
import styled from 'styled-components'; 

const ScenePaginationFooter = ({onComplete, totalSceneNum, currSceneNum, completeTxt=null, valid}) => {
    const backGroundColor = valid ? '#ffcf19' : '#D8D8D8';
    const completeButtonColor= valid ? '#121212' : '#989898';
    const sceneNumColor = valid ? '#4E4E4E' : '#989898'
    if(!currSceneNum && !totalSceneNum && [null, undefined].includes(valid))
    {
        return (
            <ScenePaginationBlock onClick={onComplete} background={'#ffcf19'}>
                <CompleteButton color={'#121212'}>
                    {completeTxt}
                </CompleteButton> 
            </ScenePaginationBlock>
        )
    }
    if(currSceneNum === totalSceneNum)
    {
        return (
            <ScenePaginationBlock onClick={valid ? onComplete : null} background={backGroundColor}>
                <CompleteButton color={completeButtonColor}>
                    완료
                </CompleteButton> 
            </ScenePaginationBlock>
        )
    }
    return (
        <ScenePaginationBlock onClick={valid ? onComplete : null} background={backGroundColor}>
            <NextButton color={completeButtonColor}>
                다음
            </NextButton> 
            <SceneNum color={sceneNumColor}>{currSceneNum} / {totalSceneNum}</SceneNum>
        </ScenePaginationBlock>    
        )
}

const ScenePaginationBlock = styled.div`
    display: flex;
    flex: 0 1 auto;
    align-items: center;
    height: calc(100vw * (73 / 375));
    background: ${({background}) => background};
    
`;

const SceneNum = styled.span`
    width: 100%;
    margin-left: calc(100vw * (8 / 375));
    font-weight: 500;
    color: ${({color}) => color};
`;

const NextButton = styled.button`
    width: 100%;
    font-weight: 700;
    font-size: calc(100vw * (18 / 375));
    text-align: end;
    color: ${({color}) => color};
`;

const CompleteButton = styled(NextButton)`
    width: 100%;
    font-weight: 700;
    font-size: calc(100vw * (18 / 375));
    text-align: center;
`;

export default ScenePaginationFooter;
